import { alpha } from '@mui/material/styles';

export const TABLE_ACTION_ICON_SX = {
  fontSize: 22,
  fontWeight: 700
};

export const getTableActionIconButtonSx = (theme) => ({
  width: 34,
  height: 34,
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.28)}`,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    color: theme.palette.primary.dark,
    backgroundColor: alpha(theme.palette.primary.main, 0.16),
    borderColor: alpha(theme.palette.primary.main, 0.45)
  }
});
